import {MultiLangField} from "@model";

export function getLanguageValue(hrValue: string | undefined, enValue: string | undefined,
                                 itValue: string | undefined, sloValue: string | undefined, srValue:string|undefined,
                                 bsValue: string|undefined,
                                 lang: string, defaultValue?: string | undefined) {
  let langValue: string | undefined = defaultValue ?? hrValue ?? enValue ?? itValue ?? sloValue ?? srValue ?? bsValue;
  switch (lang) {
    case 'hr':
      langValue = hrValue && hrValue.length > 0 ? hrValue : langValue;
      break;
    case 'en':
      langValue = enValue && enValue.length > 0 ? enValue : langValue;
      break;
    case 'it':
      langValue = itValue && itValue.length > 0 ? itValue : langValue;
      break;
    case 'slo':
      langValue = sloValue && sloValue.length > 0 ? sloValue : langValue;
      break;
    case 'sr':
      langValue = srValue && srValue.length > 0 ? srValue : langValue;
      break;
    case 'bs':
      langValue = bsValue && bsValue.length > 0 ? bsValue : langValue;
      break;
    default:
      break;
  }
  return langValue
}

export function getMultiLanguageValue(field: MultiLangField | undefined, lang: string, defaultValue?: string): string | undefined {
  return getLanguageValue(field?.hr, field?.en, field?.it, field?.sl, field?.sr, field?.bs, lang, defaultValue);
}



